import React from "react";
import { FiBell } from "react-icons/fi";
import { useNotifications } from "./NotificationProvider";
import "./Notifications.css";

export default function NotificationBell({ className = "" }) {
  const { unreadCount, setOpen } = useNotifications();

  return (
    <button
      type="button"
      className={`notif-bell-btn ${className}`}
      onClick={() => setOpen(true)}
      aria-label={`Notifications${unreadCount ? `, ${unreadCount} unread` : ""}`}
    >
      <FiBell />
      {unreadCount > 0 && (
        <span className="notif-bell-badge">{unreadCount > 9 ? "9+" : unreadCount}</span>
      )}
    </button>
  );
}
